<div class="slider-container">
	<div class="slider-input-container">
		<p-inputNumber
			*ngIf="field.UIOptions.DisplayInputField"
			class="slider-data"
			[suffix]="field.UIOptions.suffix"
			[(ngModel)]="selectedValue"
		></p-inputNumber>
	</div>
	<p-slider [min]="field.UIOptions.min" [step]="field.UIOptions.step" [max]="field.UIOptions.max"
			  (onChange)="setInputValue($event)" [formControl]="control"></p-slider>
</div>
